// Module
var code = "<div class=\"property-container\"> <label data-bind=\"text: Name\"></label> <input data-bind=\"value: Value, attr:{name: Type}\" type=\"number\" class=\"form-control\"/> </div>";
// Exports
export default code;